const data = {
  contact: 'Call us today',
  title: 'Our locations in your area',
  subtitle: (cityName: string): string =>
    `We work with a network of crematoria across ${cityName} and beyond. We’ll keep you updated on where your loved one is resting, and discuss your options for collecting or delivering the ashes.`,
}

export default data
